import ahoy from "ahoy.js";

ahoy.configure({
  visitsUrl: "/ancient-frost-1484/visits",
  eventsUrl: "/ancient-frost-1484/events",
  cookieDomain: "honeybadger.io",
  withCredentials: true,
});

document.addEventListener("turbo:load", () => {
  ahoy.trackView();
});
